export { NguParallaxModule } from './src/ngu-parallax.module';